import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';

import { formatMoney } from '@src/helpers/formatMoney';
import { DAYS_IN_WEEK } from 'entities/FullDeal/config';
import { formatDateWithOffset } from 'entities/FullDeal/lib';

import {
  LONG_TERM_FIRST_RANGE_COEFFICIENT,
  LONG_TERM_SECOND_RANGE_COEFFICIENT,
} from '../FullDealEntryPointFormCalculations/FullDealEntryPointFormCalculations.config';
import { calculateLongDebt, calculateShortDebt } from '../FullDealEntryPointFormCalculations/lib';

import styles from './FullDealCalculationsMinimal.module.scss';

interface Props {
  term: number;
  amount: number;
}
export function FullDealCalculatorCalculationsMinimal({ term, amount }: Props) {
  const withoutOverpayment = term < 22;
  const isShowShortDebt = term < 34;

  const amountWithOverpayment = calculateShortDebt(amount, term);
  const repaymentDate = formatDateWithOffset(term - 1);

  if (isShowShortDebt)
    return (
      <Space direction="row" align="center" size={8}>
        <div className={styles.badge}>0%</div>

        <Space direction="column" size={4}>
          <Text>К возврату {repaymentDate}</Text>
          <Space direction="row" size={4}>
            <Text strong size={15 as any}>
              {withoutOverpayment ? formatMoney(amount) : formatMoney(amountWithOverpayment)}
            </Text>
            {withoutOverpayment && (
              <Text size={14} className={styles.decoratedText}>
                {formatMoney(amountWithOverpayment, { withSymbol: false })}
              </Text>
            )}
          </Space>
        </Space>
      </Space>
    );

  const termByWeeks = Math.round(term / DAYS_IN_WEEK);
  const calculations = calculateLongDebt(
    amount,
    termByWeeks,
    amount > 70_000 ? LONG_TERM_SECOND_RANGE_COEFFICIENT : LONG_TERM_FIRST_RANGE_COEFFICIENT,
  );

  return (
    <Space direction="row" align="center">
      <Space direction="column" size={2}>
        <Text>Платеж раз в 2 недели</Text>
        <Text as="span" strong size={15 as any}>
          {formatMoney(calculations)}
        </Text>
      </Space>
      {/* <Space direction="column" size={2}>
        <Text size={12}>Погасить до</Text>
        <Text size={14} strong className={styles.alignRight}>
          {repaymentDate}
        </Text>
      </Space> */}
    </Space>
  );
}
